import React from 'react';
import Switch from 'react-switch';

interface CustomSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  testId?: string;
}

const switchSizes = {
  small: {
    width: 36,
    height: 16,
    handleDiameter: 14,
  },
  medium: {
    width: 44,
    height: 22,
    handleDiameter: 18,
  },
  large: {
    width: 56,
    height: 28,
    handleDiameter: 22,
  },
};

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'medium',
  testId = 'custom-switch',
}) => {
  const { width, height, handleDiameter } = switchSizes[size];

  return (
    <Switch
      className="switch"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      width={width}
      height={height}
      handleDiameter={handleDiameter}
      onColor="#239AE7"
      offColor="#8D8D8D"
      data-testid={testId}
    />
  );
};

export default CustomSwitch;
